var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('div',{staticClass:"preview-section"},[_vm._t("default"),_c('v-fade-transition',[(hover)?_c('v-overlay',{staticClass:"overlay",attrs:{"absolute":"","color":"primary","opacity":"0.3"}}):_vm._e()],1)],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }